import React from "react";

import { Container } from "@components/Container/Container";

import styles from "./styles.module.scss";
import { Box } from "@components/Box/Box";

import {
  BetterAnswerBox,
  BetterAnswerBoxProps
} from "@components/BetterAnswerBox/BetterAnswerBox";
import { Module } from "@components/Module/Module";

interface card extends BetterAnswerBoxProps {
  Headline: string;
  BodyText: string;
  TellMeMoreHeadline: string;
  TellMeMoreText: string;
}

export interface BetterAnswersPageProps extends BetterAnswerBoxProps {
  card: card;
}

const BetterAnswersPage: React.FC<BetterAnswersPageProps> = ({ card }) => {
  return (
    <Module>
      <Container inside>
        <Box className={styles.card}>
          <Box className={styles.grid}>
            <BetterAnswerBox
              BetterAnswersPage
              Question={card.Question}
              Answer={card.Answer}
              CallToAction={card.CallToAction}
            />
          </Box>
        </Box>
      </Container>
    </Module>
  );
};

export { BetterAnswersPage };
